
const urlHelper = {
  RedirectTo: (modulo) => {
    const pathname = window.location.pathname.split("/");
    if (pathname && pathname.length > 2) {
      const tokensite = pathname[2];
      window.location.href = `/${modulo}/${tokensite}`;
    } else {
      window.location.reload();
    }
  },
};

export default urlHelper;

